var chunkMapping = {
	"1535": [
		1535
	],
	"4668": [
		4668
	],
	"5883": [
		5883
	],
	"12644": [
		12644
	],
	"12823": [
		12823
	],
	"15232": [
		15232
	],
	"22045": [
		22045
	],
	"27945": [
		27945
	],
	"28190": [
		28190
	],
	"31303": [
		31303
	],
	"32106": [
		32106
	],
	"34772": [
		34772
	],
	"39819": [
		39819
	],
	"45084": [
		45084
	],
	"47290": [
		47290
	],
	"49468": [
		49468
	],
	"52031": [
		52031
	],
	"60762": [
		60762
	],
	"62567": [
		62567
	],
	"62954": [
		62954
	],
	"65985": [
		65985
	],
	"71785": [
		71785
	],
	"73687": [
		73687
	],
	"78887": [
		78887
	],
	"80437": [
		80437
	],
	"80678": [
		80678
	],
	"80744": [
		80744
	],
	"85886": [
		85886
	],
	"95356": [
		95356
	]
};
var idToExternalAndNameMapping = {
	"1535": [
		"default",
		"./shoppingRewardInquiry",
		86793
	],
	"4668": [
		"default",
		"./shoppingRewardGuide",
		86793
	],
	"5883": [
		"default",
		"./adReward",
		86793
	],
	"12644": [
		"default",
		"./raffleRandomMission",
		86793
	],
	"12823": [
		"default",
		"./onePickResult",
		86793
	],
	"15232": [
		"default",
		"./wordRelayMyRanking",
		86793
	],
	"22045": [
		"default",
		"./roulette",
		86793
	],
	"27945": [
		"default",
		"./nasMediaCS",
		86793
	],
	"28190": [
		"default",
		"./wordRelayMasterSecret",
		86793
	],
	"31303": [
		"default",
		"./chat",
		58934
	],
	"32106": [
		"default",
		"./onePickSuggest",
		86793
	],
	"34772": [
		"default",
		"./wordRelay",
		86793
	],
	"39819": [
		"default",
		"./wordRelayMain",
		86793
	],
	"45084": [
		"default",
		"./onePickHistory",
		86793
	],
	"47290": [
		"default",
		"./shoppingRewardMall",
		86793
	],
	"49468": [
		"default",
		"./shoppingRewardHistory",
		86793
	],
	"52031": [
		"default",
		"./nasMedia",
		86793
	],
	"60762": [
		"default",
		"./bithumb",
		86793
	],
	"62567": [
		"default",
		"./gasAppEvent",
		86793
	],
	"62954": [
		"default",
		"./wordRelayRanking",
		86793
	],
	"65985": [
		"default",
		"./ladder",
		86793
	],
	"71785": [
		"default",
		"./shoppingRewardHome",
		86793
	],
	"73687": [
		"default",
		"./shoppingRewardCoupang",
		86793
	],
	"78887": [
		"default",
		"./raffle",
		86793
	],
	"80437": [
		"default",
		"./gacha",
		86793
	],
	"80678": [
		"default",
		"./wordRelayLevel",
		86793
	],
	"80744": [
		"default",
		"./raffleInviteFriends",
		86793
	],
	"85886": [
		"default",
		"./raffleInviteFriendsInquiry",
		86793
	],
	"95356": [
		"default",
		"./onePick",
		86793
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}